import { isRequired as validateRequired } from '../../../utils/validation';

export const initialValues = {
  title: '',
  content: '',
  version: '',
  isEnabled: 'true',
  isRequired: 'true'
};

export const fieldsProps = {
  title: {
    name: 'title',
    placeholder: 'Masukkan Judul',
    label: 'Judul',
  },
  content: {
    name: 'content',
    placeholder: 'Masukkan Deskripsi',
    label: 'Deskripsi',
  },
  version: {
    name: 'version',
    placeholder: 'Masukkan Versi',
    label: 'Versi',
  },
  isEnabled: {
    name: 'isEnabled',
    label: 'Status',
  },
  isRequired: {
    name: 'isRequired',
    label: 'Jenis Persetujuan',
  },
};

export const validate = (values = initialValues) => {
  const { title, content, version } = values;
  const rules = {
    title: validateRequired(title, 'Judul harus diisi'),
    content: validateRequired(content, 'Deskripsi harus diisi'),
    version: validateRequired(version, 'Versi harus diisi')
  };
  return rules;
};
